import Financial from "../../component/financial/Financial";
import MFinancial from "../../component/mobile/financial/MFinancial";



const FINANCIAL=()=>{
  return(
    <div className="FINANCIAL">
      {window.innerWidth > 1000 && <Financial/>}
      {window.innerWidth < 1000 && <MFinancial/>}
    </div>
  )
}

export default FINANCIAL;